module.exports = {
  "border": {
    "borderBottomWidth": "1",
    "borderBottomColor": "#dddddd"
  },
  "wxc-skid": {
    "flexDirection": "row",
    "backgroundColor": "#FFFFFF"
  },
  "swipe-action-right": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "swipe-action-center": {
    "width": "750"
  },
  "swipe-action-child": {
    "width": "100",
    "textAlign": "center",
    "color": "#FFFFFF",
    "backgroundColor": "#dddddd",
    "lineHeight": "90"
  },
  "swipe-action-text": {
    "fontSize": "30"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-c855898a!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-swipe-action/index.vue
// module id = 193
// module chunks = 0 1